var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-socialmedia-popup.ts
import { AdornisRouter } from "@adornis/base/client/a-router";
import { isPrinting } from "@adornis/base/client/frontend-helpers";
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element";
import { ObservableController } from "@adornis/chemistry/controllers/observable-controller";
import { event } from "@adornis/chemistry/decorators/event";
import { acss } from "@adornis/chemistry/directives/acss";
import { css } from "@adornis/chemistry/directives/css";
import "@adornis/chemistry/elements/components/x-flex";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/chemistry/elements/components/x-link";
import { xComponents } from "@adornis/chemistry/elements/x-components";
import "@adornis/chemistry/renderable";
import "@adornis/fonts/fonts";
import { html, nothing } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { fromEvent } from "rxjs";
import { takeUntil } from "rxjs/operators";
import instagram from "../assets/iconinstagram.png";
import linkedin from "../assets/iconlinkedin.png";
import socialmedia from "../assets/iconsocialmedia.png";
import twitter from "../assets/icontwitter.png";
import youtube from "../assets/iconyoutube.png";
import "../fonts";
var ElementsSocialMediaPopup = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.label = "";
    this.open = false;
    this.page = new ObservableController(this, AdornisRouter.get("page"));
    this.isPrinting = new ObservableController(this, isPrinting);
    this.blacklist = ["login", "signup", "create_profile", "welcome_box"];
  }
  connectedCallback() {
    super.connectedCallback();
    fromEvent(this, "focusin").pipe(takeUntil(this.disconnected)).subscribe(() => this.open = true);
  }
  render() {
    if (this.blacklist.includes(this.page.value || ""))
      return nothing;
    return xComponents(html`
      <x-flex
        crossaxis-center
        ${acss({
      width: "75px"
    })}
      >
        <x-flex
          id="content"
          crossaxis-center
          ${acss({
      height: this.open ? "unset" : "0",
      width: this.open ? "75px" : "0",
      overflow: "hidden",
      paddingTop: this.open ? this.spacing.md : "0",
      paddingBottom: this.open ? this.spacing.md : "0",
      border: "solid",
      borderColor: "white",
      borderRadius: "50px",
      borderWidth: "0px",
      boxShadow: "0px 5px 10px 0px rgba(0, 0, 0, 0.5)",
      backgroundColor: "white"
    })}
        >
          <x-link href="https://www.facebook.com/">
            <x-icon ${css({ fontSize: "27px", padding: "10px", color: this.colors.accent })}> facebook </x-icon>
          </x-link>
          <x-link href="https://www.instagram.com/">
            <img
              ${css({
      width: "24px",
      padding: "10px"
    })}
              src=${instagram}
            />
          </x-link>
          <x-link href="https://de.linkedin.com/">
            <img
              ${css({
      width: "25px",
      padding: "10px"
    })}
              src=${linkedin}
            />
          </x-link>
          <x-link href="https://www.youtube.com/">
            <img
              ${css({
      width: "25px",
      padding: "10px"
    })}
              src=${youtube}
            />
          </x-link>
          <x-link href="https://twitter.com/?lang=de">
            <img
              ${css({
      width: "25px",
      padding: "10px"
    })}
              src=${twitter}
            />
          </x-link>
        </x-flex>
        <br />
        <x-flex
          space="md"
          ${acss({
      cursor: "pointer",
      userSelect: "none",
      backgroundImage: `url(${socialmedia})`,
      height: "66px",
      width: "66px",
      borderColor: "white",
      borderRadius: "50px",
      borderWidth: "1px",
      padding: "20px",
      backgroundPosition: "center",
      backgroundRepeat: "no-repeat",
      backgroundColor: "white",
      boxShadow: "0px 5px 10px 0px rgba(0, 0, 0, 0.5)"
    })}
          @click="${() => {
      this.open = !this.open;
      if (!this.open)
        this.blur();
    }}"
        >
        </x-flex>
      </x-flex>
    `);
  }
};
__decorateClass([
  property({ type: String })
], ElementsSocialMediaPopup.prototype, "label", 2);
__decorateClass([
  property({ reflect: true, type: Boolean }),
  event
], ElementsSocialMediaPopup.prototype, "open", 2);
__decorateClass([
  state()
], ElementsSocialMediaPopup.prototype, "page", 2);
__decorateClass([
  state()
], ElementsSocialMediaPopup.prototype, "isPrinting", 2);
ElementsSocialMediaPopup = __decorateClass([
  customElement("ge-socialmedia-popup")
], ElementsSocialMediaPopup);
export {
  ElementsSocialMediaPopup
};
